(() => {
  if (customElements.get('jobski-scent-finder')) return;
  class JobskiScentFinder extends HTMLElement {
    static formula(answers) {
      const types=['oil','serum','butter'];
      const weights=[
        {a:[3,1,0],b:[1,3,0],c:[0,0,4],d:[1,2,0]},
        {a:[0,3,0],b:[3,1,0],c:[0,0,3]},
        {a:[1,2,0],b:[3,1,0],c:[0,0,3],d:[1,1,0]}
      ];
      return types.map((kind,i)=>({kind,score:weights.reduce((s,q,n)=>s+(q[answers[n]]?.[i]||0),0),first:weights[0][answers[0]]?.[i]||0,i}))
        .sort((x,y)=>y.score-x.score||y.first-x.first||x.i-y.i)[0].kind;
    }
    static scentOrder(answer) {
      return ({a:['american','ginger','champion','golden'],b:['golden','american','ginger','champion'],c:['ginger','american','golden','champion'],d:['champion','ginger','golden','american']})[answer]||['american','ginger','champion','golden'];
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.cards = [...this.querySelectorAll('[data-line]')];
      this.form = this.querySelector('[data-quiz]');
      this.position = 0;
      this.onClick = event => {
        if (event.target.closest('[data-start]')) this.start();
        if (event.target.closest('[data-restart]')) this.reset();
        if (event.target.closest('[data-edit]')) this.start();
        if (event.target.closest('[data-back]') && this.position > 0) { this.position--; this.showStep(); }
        if (event.target.closest('[data-next]') && this.selected(this.position) && this.position < this.steps.length - 1) { this.position++; this.showStep(); }
      };
      this.onChange = () => this.updateControls();
      this.onSubmit = event => {
        event.preventDefault();
        if (this.steps.every((_, index) => this.selected(index))) this.showResult();
      };
      this.addEventListener('click', this.onClick);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      this.querySelector('[data-entry]').hidden = false;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.ready = false;
    }
    selected(index) { return this.steps[index].querySelector('input:checked')?.value; }
    start() {
      this.dataset.engaged = "true";
      this.closest('.jk-finder').classList.remove('is-results');
      this.querySelector('[data-entry]').hidden = true;
      this.querySelector('[data-result]').hidden = true;
      this.form.hidden = false;
      this.querySelector('[data-guide]').hidden = true;
      this.querySelector('[data-lines]').hidden = true;
      this.querySelector('[data-all]').hidden = true;
      this.position = 0;
      this.showStep();
    }
    updateControls() {
      const valid = Boolean(this.selected(this.position));
      const last = this.position === this.steps.length-1;
      this.querySelector('[data-back]').hidden = this.position === 0;
      this.querySelector('[data-next]').hidden = last;
      this.querySelector('[data-next]').disabled = !valid;
      this.querySelector('[data-finish]').hidden = !last;
      this.querySelector('[data-finish]').disabled = !valid;
    }
    showStep() {
      this.steps.forEach((step,index) => { step.hidden = index !== this.position; });
      this.querySelector('[data-progress-label]').textContent = this.dataset.progress+' '+(this.position+1)+' '+this.dataset.of+' '+this.steps.length;
      this.updateControls();
      this.querySelector('[data-progress]').value=this.position+1;
      const legend=this.steps[this.position].querySelector('legend');
      legend.focus({ preventScroll: true });
      legend.scrollIntoView({block:'start',behavior:'instant'});
    }
    copy(kind,pl) {
      const c={
        oil:[pl?'Olejek':'Beard oil',pl?'Najlepszy wybór dla Ciebie: olejek':'Best match for you: beard oil',pl?'Olejek zmiękcza zarost, wspiera pielęgnację skóry pod brodą i pomaga ograniczyć uczucie suchości.':'Beard oil softens the hair, cares for the skin underneath and helps ease the feeling of dryness.',pl?'Ten zapach nie występuje w olejku. Pokazujemy najbliższy dostępny profil zapachowy.':'This scent is not available as an oil, so we chose the closest available scent profile.'],
        serum:[pl?'Serum':'Beard serum',pl?'Najlepszy wybór dla Ciebie: serum':'Best match for you: beard serum',pl?'Lekkie serum wygładza zarost, ujarzmia puszenie i nadaje miękki połysk bez obciążania brody.':'The lightweight serum smooths the beard, tames flyaways and adds a soft sheen without weighing it down.',pl?'Ten zapach nie występuje w serum. Pokazujemy najbliższy dostępny profil zapachowy.':'This scent is not available as a serum, so we chose the closest available scent profile.'],
        butter:[pl?'Butter Elixir':'Butter Elixir',pl?'Najlepszy wybór dla Ciebie: Butter Elixir':'Best match for you: Butter Elixir',pl?'Masła, skwalan i woski łączą pielęgnację z lekkim chwytem, który pomaga ułożyć brodę.':'Butters, squalane and waxes combine care with light hold to shape and control the beard.',pl?'Ten zapach nie występuje w Butter Elixir. Pokazujemy najbliższy dostępny profil zapachowy.':'This scent is not available in Butter Elixir, so we chose the closest available scent profile.']
      };return c[kind];
    }
    supports(card,kind,availableOnly=false){return [...card.querySelectorAll('[data-product-kind]')].some(p=>p.dataset.productKind===kind&&(!availableOnly||p.dataset.available==='true'));}
    chooseCard(order,kind) {
      return [true,false].flatMap(availableOnly=>order.map(line=>this.cards.find(c=>c.dataset.line===line&&this.supports(c,kind,availableOnly)))).find(Boolean);
    }
    bundleSupports(line,kind){const m={american:['oil','butter'],ginger:['oil','butter'],golden:['serum','butter'],champion:['serum']};return(m[line]||[]).includes(kind);}
    showResult() {
      const answers=this.steps.map((_,i)=>this.selected(i)),kind=JobskiScentFinder.formula(answers),order=JobskiScentFinder.scentOrder(answers[3]);
      const card=this.chooseCard(order,kind);if(!card)return;
      const pl=(document.documentElement.lang||'en').startsWith('pl'),copy=this.copy(kind,pl);
      this.cards.forEach(c=>{c.hidden=c!==card;c.classList.remove('is-primary');});card.classList.add('is-primary');
      card.querySelector('[data-rank]').textContent=copy[0]+(card.dataset.line===order[0]?'':(pl?' · alternatywny zapach':' · alternative scent'));
      card.querySelector('[data-rank]').hidden=false;
      const reason=card.querySelector('[data-formula-description]');if(reason)reason.textContent=copy[2];
      const fallback=card.querySelector('[data-fallback]');
      fallback.hidden=card.dataset.line===order[0];
      const preferred=this.cards.find(c=>c.dataset.line===order[0]);
      fallback.textContent=preferred&&this.supports(preferred,kind)?this.dataset.soldOutFallback:this.dataset.formulaFallback;
      card.querySelectorAll('[data-product-kind]').forEach(p=>p.hidden=p.dataset.productKind!==kind);
      const bundle=card.querySelector('.jk-scent__bundle');if(bundle){bundle.hidden=!this.bundleSupports(card.dataset.line,kind);bundle.open=false;}
      card.querySelector('[data-reason]').hidden=true;
      this.querySelector('.jk-finder__result-title').textContent=copy[1];this.form.hidden=true;this.querySelector('[data-guide]').hidden=false;this.querySelector('[data-lines]').hidden=false;this.querySelector('[data-all]').hidden=true;this.querySelector('[data-result]').hidden=false;this.closest('.jk-finder').classList.add('is-results');this.querySelector('.jk-finder__result-title').focus({preventScroll:true});this.querySelector('.jk-finder__result-title').scrollIntoView({block:'start',behavior:'instant'});
    }
    reset() {
      delete this.dataset.engaged;
      this.form.reset();
      this.querySelector('[data-guide]').open=false;
      this.querySelector('[data-guide]').hidden = true;
      this.form.hidden = true;
      this.querySelector('[data-entry]').hidden = false;
      this.querySelector('[data-result]').hidden = true;
      this.querySelector('[data-all]').hidden = true;
      const container = this.querySelector('[data-lines]');
      container.hidden = true;
      this.closest('.jk-finder').classList.remove('is-results');
      this.cards.forEach(card => {
        card.hidden = true;
        card.classList.remove('is-primary');
        card.querySelector('[data-rank]').hidden = true;
        card.querySelector('[data-reason]').hidden = true;
        card.querySelector('[data-fallback]').hidden = true;
        card.querySelectorAll('[data-product-kind]').forEach(product => { product.hidden = false; });
        container.append(card);
      });
      this.querySelector('[data-start]').focus({ preventScroll:true });
    }
  }
  customElements.define('jobski-scent-finder', JobskiScentFinder);
})();